import { useState, useEffect, MutableRefObject } from 'react'

const useIntersection = ({
  ref,
  options = {
    rootMargin: '0px',
  },
  callback,
}: {
  ref?: MutableRefObject<HTMLElement>;
  options?: IntersectionObserverInit;
  callback?: (isVisible: boolean) => void;
}) => {
  const [isVisible, setState] = useState(false);

  useEffect(() => {
    const element = ref?.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setState(entry.isIntersecting);

        if (callback) {
          callback(entry.isIntersecting);
        }
      },
      options,
    );

    element && observer.observe(element);

    return () => element && observer.unobserve(element);
  }, [ref, options, callback]);

  return isVisible;
};

export default useIntersection;
